import React from "react";
import { Modal, Button } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRecycle } from "@fortawesome/free-solid-svg-icons";

const PaymentClearConfirmationModal = ({ show, onClose, onConfirm, selectedPayment }) => {
    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Body className="p-4">
                <FalconCloseButton
                    onClick={onClose}
                    size="sm"
                    className="position-absolute top-0 end-0 me-2 mt-2"
                />
                <Flex direction="column" alignItems="center">
                    <div
                        className="rounded-circle bg-subtle-primary d-flex flex-center mb-3"
                        style={{ width: "60px", height: "60px" }}
                    >
                        <FontAwesomeIcon icon={faRecycle} className="text-primary fs-3" />
                    </div>
                    <h5 className="mb-2">Mark as Cleared?</h5>
                    <p className="text-center text-700 fs-10 mb-4">
                        Are you sure you want to mark payment <strong>{selectedPayment?.paymentno}</strong> as cleared?
                        This will update the reconciliation status of all associated claims.
                    </p>
                    <Flex className="gap-4">
                        <Button
                            variant="falcon-default"
                            size="sm"
                            className="px-4"
                            onClick={onClose}
                        >
                            No, Cancel
                        </Button>
                        <Button
                            variant="primary"
                            size="sm"
                            className="px-4 shadow-none"
                            onClick={onConfirm}
                        >
                            Yes, Confirm
                        </Button>
                    </Flex>
                </Flex>
            </Modal.Body>
        </Modal>
    );
};

export default PaymentClearConfirmationModal;
